import { Injectable, ViewContainerRef } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  /** The global numerical ID of the component that is displayed into the sidebar. */
  sidebarOpened: number = null;

  sidebarDrawer: MatDrawer;

  sidebarRef: ViewContainerRef;

  constructor() {}

  closeSidebar() {
    this.sidebarOpened = null;
    this.sidebarDrawer.close();
  }
}
